module.exports = __webpack_public_path__ + "static/img/Snipaste_2022-01-20_20-04-05.124dea4b.png";